// eslint-disable-next-line import/prefer-default-export
export const COOKIES_NAME = 'prox_jwt_admin_token';
